
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { AiOutlineLogout } from 'react-icons/ai';
import Container from 'react-bootstrap/Container';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import Cookies from 'js-cookie';
//import SessionTime from './SessionTime';
import { useNavigate } from "react-router-dom";
import { useQueryClient } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';
import { CommonAxiosPost } from '../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../CommonUtils/CommonUrl/CommonUrls';
const Header = () => {
  const dispatch = useDispatch();
  const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails);
  let navigate = useNavigate()
  const queryClient = useQueryClient();
  function logout() {
    CommonAxiosPost(config.url.BOC_URL + "logoutt")
    dispatch({ type: "USER_LOGOUT" });
    window.sessionStorage.removeItem('jwtToken');
    Cookies.remove("jwtToken")
    Cookies.remove("jwtRefreshToken")
    localStorage.clear()
    navigate("/")
    queryClient.clear();
  }
  const lastLoginMillis = loginreducer?.loginData?.last_login_time;
  const lastLoginDate = new Date(lastLoginMillis);

  const formattedDate = lastLoginDate.toLocaleString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });



  return (
    <React.Fragment>
      <Navbar collapseOnSelect expand="lg" bg="white" sticky="top" variant="light">
        <Container >
          <Navbar.Brand href="/" style={{ color: 'green', fontWeight: 'bold' }}><img src="../img/BOC.png" width="250px" alt="fewsr" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          {/* <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">

            </Nav>
            <Nav className="me-auto">
            </Nav>
            <Nav> */}
          <NavDropdown
            title={
              <>
                <span style={{ fontSize: "13px", marginRight: "8px" }}>
                  <span style={{ color: "green", fontWeight: "bold" }}>Last Login :</span>{" "}
                  <span style={{ color: "black", fontWeight: "bold" }}>{formattedDate}</span>
                </span>
                &nbsp; &nbsp;&nbsp;
                <b>{loginreducer?.loginData?.full_name}({loginreducer?.loginData?.username})
                  {/* -{loginreducer?.loginData?.mandal_name} */}
                  </b>
              </>
            }
            id="collasible-nav-dropdown"
            align="end"
          >
            <NavDropdown.Item onClick={logout}>
              <AiOutlineLogout style={{ fontSize: "18px" }} /> Signout
            </NavDropdown.Item>
          </NavDropdown>

          {/* </Nav>
          </Navbar.Collapse> */}
        </Container>
      </Navbar>
    </React.Fragment>
  );
}
export default Header;
